import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productDucInfoApi = createApi({
    reducerPath: "productDucInfoApi",
    baseQuery,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("userToken");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("X-Request-Id", crypto.randomUUID());
      return headers;
    },
    tagTypes: ["productDucInfo"],
    endpoints: (builder) => ({
     
        createProductDucInfo: builder.mutation({
            query: ({ id,...data }) => ({
              url: `/export/product/ducRef/${id}`, ///v1/export/product/ducRef/{exportProductId}
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { ducRef:data },
            }),
            invalidatesTags: ["productDucInfo"],
          }),

          getDucInfoDetailsById: builder.query({
            query: ({id}) => `export/product/ducRef/${id}`,
            transformResponse: (response) => 
              {
                const data= response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item,index) => ({
                  ...item,
                  SrNo:index+1,
                  id: item.exportProductDUCRefNoId, // 👈 use backend's exportEntityId
                }));

              },
            providesTags: ["productDucInfo"],
          }), 
  
          updateProductDucInfo: builder.mutation({
            query: ({ id,subId, ...data }) => ({
              url: `/export/product/ducRef/${id}/${subId}`,
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { ducRef:data },
            }),
            invalidatesTags: ["productDucInfo"],
          }),
      
          deleteProductDucInfo: builder.mutation({
            query: ({ id}) => ({
              url: `export/product/ducRef/${id}`,
              method: "DELETE",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
            }),
            invalidatesTags: ["productDucInfo"],
          }),
         

      }), 
    }); 

    export const {
      useCreateProductDucInfoMutation,  //getDucInfoDetailsById
      useLazyGetDucInfoDetailsByIdQuery,  //getDucInfoDetailsById
      useUpdateProductDucInfoMutation,
      useDeleteProductDucInfoMutation

      } = productDucInfoApi;
